// The post-call email panel's opening "Kind of email" (scripts audit F4, 2026-10-10). Pure; EmailPanel.tsx uses it.
import type { QueueItem } from '../../../src/shared/api';
import type { SalesEmailType } from '../../../src/shared/api-sales-email';

/** The kind of email the panel opens with, from the campaign's offer (the SMS drafter's mapping, smsDraft.ts:384): a
 *  front_desk campaign drafts Get Answered (AI receptionist); any other offer (website_seo, the dispensary campaigns)
 *  drafts Get Found (website, Google, local SEO). A no-campaign call keeps Get Answered, the panel's old default (not
 *  'custom': it fails without notes). The setter can still pick any kind before Draft. */
export function defaultEmailType(item: Pick<QueueItem, 'campaign' | 'noCampaign'>): SalesEmailType {
  const offer = item.noCampaign ? '' : item.campaign.offer;
  return offer === 'front_desk' || !offer ? 'front_desk' : 'leads_marketing';
}
